import { Grid, Stack, Typography } from "@mui/material";
import DataGrid from "global/components/UI/DataGrid/DataGrid";
import { useWindowViewport } from "global/hook/windowViewport/use-window-viewport";
import { TabControlContext } from "page/Automatensuche/components/TabControl/TabControlProvider";
import { useContext } from "react";
import ErreichbarkeitService from "service/data-service/reporting-controller/Erreichbarkeit.service";
import { Erreichbarkeit } from "service/data-service/reporting-controller/interface/Erreichbarkeit";
import ExportService from "service/report-service/export/Export.service";
import ErreichbarkeitColumnDefs from "./grid-column-defs";

const KommArt: React.FC = () => {
  const tabControlCtx = useContext(TabControlContext);
  const windowViewport = useWindowViewport(0, 210)

  return (
    <Stack className="erreichbarkeitRecords">
      <Grid container spacing={1} width={"auto"}>
        <Grid item xs={12} mt={3}>
          <Typography variant={"h1"}>Erreichbarkeiten je KommArt</Typography>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            height={windowViewport.height}
            columnDefs={ErreichbarkeitColumnDefs}
            onRowClicked={(row: Erreichbarkeit) => {
              tabControlCtx.push(row.serienNr, row.automatKey);
            }}
            exportDef={{ action: ExportService.downloadErreichbarkeit }}
            rowsDataDef={{
              uncontrolledDataFetchCall: ErreichbarkeitService.getReport,
            }}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};
export default KommArt;
